export default __webpack_public_path__ + "files/aces logo-1d6059c0c151033c6c40e022eb325d53.png";